export function FormatApplicant(hit, isPostulation) {
  let applicant = isPostulation ? hit._source.applicant : hit._source;

    return {
      value: applicant.id,
      label: `${ applicant.user.personal_information.first_name } ${ applicant.user.personal_information.last_name }`
    }
}
